import React from "react";

// ==================== 1. 定义不同 Type 对应的独立组件 (Div结构) ====================

// 限时标签 (Type 1)
const TagType1 = ({ item }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginRight: "5px",
      backgroundColor: "#FFF6F6",
      borderRadius: "3px",
      color: "#FC2727",
      flexShrink: "0",
    }}
  >
    <img
      src="resources/250627/xianshi.png"
      alt=""
      height={11}
      style={{ flexShrink: 0, paddingLeft: "4px" }}
    />
    <div
      style={{
        fontSize: "10px",
        padding: "0 5px 0 3px",
        height: "15px",
        lineHeight: "15px",
        flexShrink: "0",
      }}
    >
      {item.name}
    </div>
  </div>
);

// 精品标签 (Type 2)
const TagType2 = ({ item }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginRight: "5px",
      backgroundColor: "#FFF0F0",
      borderRadius: "3px",
      color: "#FC2727",
      flexShrink: "0",
    }}
  >
    <img
      src="resources/250627/type2.png"
      alt=""
      height={11}
      style={{ flexShrink: 0, paddingLeft: "4px" }}
    />
    <div
      style={{
        fontSize: "10px",
        padding: "0 5px 0 3px",
        height: "15px",
        lineHeight: "15px",
        flexShrink: "0",
      }}
    >
      {item.name}
    </div>
  </div>
);

// 灰色圆角纯文本标签 (Type 3)
const TagType3 = ({ item }) => (
  <div
    style={{
      color: "#0396FF",
      backgroundColor: "#EDF8FF",
      borderRadius: "3px",
      padding: "0px 5px",
      marginRight: "5px",
      fontSize: "10px",
      height: "15px",
      lineHeight: "15px",
      display: "flex",
      alignItems: "center",
      flexShrink: "0",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {item.name}
  </div>
);

// 灰色无背景纯文本标签 (Type 4)
const TagType4 = ({ item }) => (
  <div
    style={{
      color: "#888",
      backgroundColor: "transparent",
      borderRadius: "0",
      padding: "0",
      marginRight: "5px",
      fontSize: "11px",
      height: "15px",
      lineHeight: "15px",
      display: "inline-block",
      alignItems: "center",
      flexShrink: "1",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {item.name}
  </div>
);

// 新增小号标签 (Type 5)
const TagType5 = ({ item }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginRight: "5px",
      backgroundColor: "#FFF6F6",
      borderRadius: "3px",
      color: "#FC2727",
      flexShrink: "0",
    }}
  >
    <img
      src="resources/250627/type5.png"
      alt=""
      height={11}
      style={{ flexShrink: 0, paddingLeft: "4px" }}
    />
    <div
      style={{
        fontSize: "0.2rem",
        padding: "0 5px 0 3px",
        height: "15px",
        lineHeight: "15px",
        flexShrink: "0",
      }}
    >
      {item.name}
    </div>
  </div>
);

// ==================== 2. 根据 type 映射组件的字典表 ====================
const TAG_COMPONENTS = {
  1: TagType1,
  2: TagType2,
  3: TagType3,
  4: TagType4,
  5: TagType5,
};

// ==================== 3. 主导出组件 ====================
export default function GameTags(props) {
  // 安全防护：如果 dynamic_label_classifity 未定义，默认使用空数组避免报错
  const classifity = props.game?.dynamic_label_classifity || [];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        paddingTop: "2px",
        flexWrap: "nowrap",
      }}
    >
      {classifity.map((item, index) => {
        // 根据 item.type 直接获取对应的 React 组件
        const TagComponent = TAG_COMPONENTS[item.type];

        // 动态加载组件，每个组件保持最纯粹的 div 内部结构
        return <TagComponent key={index} item={item} />;
      })}
    </div>
  );
}
